export const createMenuEntrance = menu => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const animations = new Set();
    let frame = null;
    let loadingObserver = null;

    const cancel = () => {
        cancelAnimationFrame(frame);
        loadingObserver?.disconnect();
        frame = loadingObserver = null;
        for (const animation of animations) animation.cancel();
        animations.clear();
    };

    const play = gridSelector => {
        cancel();
        if (reducedMotion.matches) return;

        const start = () => {
            frame = requestAnimationFrame(() => {
                frame = null;
                if (reducedMotion.matches || !menu.getClientRects().length) return;
                const elements = [
                    menu.querySelector('.header .logo'),
                    ...menu.querySelectorAll(`${gridSelector} > div`),
                ].filter(element => element?.getClientRects().length);
                // Measure before starting effects; hover scale remains independent.
                const bounds = elements.map(element => element.getBoundingClientRect());
                const tilts = [-8, 9, -7, 11, -10, 6];
                elements.forEach((element, index) => {
                    const tilt = tilts[index % tilts.length];
                    const animation = element.animate([
                        {offset: 0, translate: `${tilt * 3}px ${-bounds[index].bottom - 60}px`, rotate: `${tilt}deg`, scale: '1', easing: 'cubic-bezier(.45, 0, .9, .65)'},
                        {offset: .5, translate: '0 6px', rotate: `${-tilt * .2}deg`, scale: '1.05 .94', easing: 'cubic-bezier(.15, .7, .3, 1)'},
                        {offset: .7, translate: '0 -32px', rotate: `${tilt * .14}deg`, scale: '.98 1.02', easing: 'cubic-bezier(.5, 0, .85, .4)'},
                        {offset: .84, translate: '0 3px', rotate: `${-tilt * .07}deg`, scale: '1.015 .985', easing: 'cubic-bezier(.15, .7, .3, 1)'},
                        {offset: .94, translate: '0 -5px', rotate: `${tilt * .03}deg`, scale: '1', easing: 'ease-in'},
                        {offset: 1, translate: '0 0', rotate: '0deg', scale: '1'},
                    ], {
                        duration: index === 0 ? 950 : 1080,
                        delay: index * 85,
                        fill: 'backwards',
                    });
                    animations.add(animation);
                    animation.onfinish = () => {
                        animations.delete(animation);
                        animation.cancel();
                    };
                });
            });
        };

        const preloader = document.getElementById('preloader');
        if (preloader && !preloader.classList.contains('hide')) {
            loadingObserver = new MutationObserver(() => {
                if (!preloader.classList.contains('hide')) return;
                loadingObserver.disconnect();
                loadingObserver = null;
                // Start in the next paint as the loading doors open.
                start();
            });
            loadingObserver.observe(preloader, {attributes: true, attributeFilter: ['class']});
        } else {
            start();
        }
    };

    reducedMotion.addEventListener('change', event => {
        if (event.matches) cancel();
    });
    return {play, cancel};
};
